import React from 'react';
import { inject, observer } from 'mobx-react';
import { PageCenterWrapper, Box } from '@styles/globalStyles';
import SignInForm from './components/SignInForm';

const SignInPage = inject('authStore')(
  observer(({ authStore: { signIn } }) => (
    <PageCenterWrapper>
      <img src="/images/intervox-logo.png" alt="intervox" />
      <Box>
        <SignInForm onSubmit={signIn} />
      </Box>
    </PageCenterWrapper>
  )),
);

export default SignInPage;
